import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Iter34 — Build a clear, contextual title for a video task.
 * Format: "Vidéo 1 · Nash" when client present, "Vidéo 1 · {project_name}" otherwise.
 * Falls back to raw title for non-video tasks or when no project context.
 */
export function taskDisplayTitle(task, projectsById) {
  if (!task) return '';
  const base = task.title || '';
  if (task.kind !== 'video' || !task.project_id) return base;
  const proj = projectsById?.[task.project_id] || projectsById?.get?.(task.project_id);
  if (!proj) return base;
  const suffix = proj.client || proj.name;
  if (!suffix || base.includes(suffix)) return base;
  return `${base} · ${suffix}`;
}

/**
 * Iter35 — Safely stringify any error coming from axios / FastAPI.
 * FastAPI 422 returns `detail` as an array of Pydantic error objects which
 * cannot be rendered directly as React children → would crash the UI.
 */
export function formatApiError(err, fallback = 'Erreur') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => {
      if (typeof d === 'string') return d;
      const loc = Array.isArray(d?.loc) ? d.loc.filter((p) => p !== 'body').join('.') : '';
      return `${loc ? loc + ': ' : ''}${d?.msg || JSON.stringify(d)}`;
    }).join(' · ');
  }
  if (detail && typeof detail === 'object') {
    return detail.msg || JSON.stringify(detail);
  }
  return err?.message || fallback;
}
